export const AUTH_INVALID_EMAIL = 'auth/invalid-email'
export const AUTH_USER_DISABLED = 'auth/user-disabled'
export const AUTH_USER_NOT_FOUND = 'auth/user-not-found'
export const AUTH_WRONG_PASSWORD = 'auth/wrong-password'
export const AUTH_TOO_MANY_REQUESTS = 'auth/too-many-requests'
export const AUTH_INVALID_ACTION_CODE = 'auth/invalid-action-code'
export const AUTH_EMAIL_DUPLICATE_EMAIL = 'auth/email-already-in-use'
export const AUTH_WEEK_PASSWORD = 'auth/week-password'
